import React from 'react';

export default class LeagueForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                name: "",
                id: '',
                created: '',
                qualifiers: 0,
                tournament_id:0,
                tournament_name: ''
            }
        };
    }

    componentWillMount(){
        let st = {...this.props.selected}
        this.setState({selected: st});
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.selected)
        }
    }

    render(){
        return(
            <div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Nombre</label>
                    </div>
                    <div className="field-body">
                        <input className="input" type="text" autoFocus onKeyPress={(e) => this.handleKeyPress(e)} placeholder="" value={this.state.selected.name} onChange={(e) => {
                            let state = {...this.state};
                            state.selected.name = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Pasantes a liguilla</label>
                    </div>
                    <div className="field-body">
                        <input className="input" type="number" onKeyPress={(e) => this.handleKeyPress(e)} value={this.state.selected.qualifiers} onChange={(e) => {
                            let state = {...this.state};
                            state.selected.qualifiers = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Torneo</label>
                    </div>
                    <div className="field-body">
                        <select
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            className="input"
                            onChange={(e) => {
                                let state = {...this.state};
                                let index = e.currentTarget.selectedIndex -1;
                                state.selected.tournament_id = this.props.tournaments[index].id;
                                state.selected.tournament_name = this.props.tournaments[index].name;
                            }}
                        >
                            <option disabled={true} selected={true}>Seleccionar...</option>
                            {this.props.tournaments.map(t => {
                                return (
                                    <option key={t.id} selected={t.id==this.state.selected.tournament_id ? "selected" :"" }>
                                        {t.name}
                                    </option>
                                )
                            })}

                        </select>
                    </div>
                </div>
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        <button
                            className="button is-success"
                            onClick={() => this.props.save(this.state.selected)}>
                            Guardar
                        </button>
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/league/form.js